export default {
	title: "Goal",
	teamLabel: "Team",
	dueLabel: "Due",
	lastUpdatedLabel: "Last updated",
	confidenceLabel: "Confidence",
	progressAndPacingLabel: "Progress & Pacing",
};
